import { FC, HTMLAttributes } from "react";

import { Link, LinkProps } from "./Link";

import "./IconButton.css";

interface IconButtonProps extends HTMLAttributes<HTMLButtonElement> { }

export const IconButton: FC<IconButtonProps> = props => (
  <button {...props} className={`icon-button ${props.className || ""}`} />
)

export const IconButtonLink: FC<LinkProps> = props => (
  <Link {...props} className={`icon-button ${props.className || ""}`} />
)